const B_1 = [
    {
        title: '核实标书款',
        path: '/manage/finance/auditbsk/list'
    }
]

export default {
    path: 'auditbsk',
    component: () => import(/*webpackChunkName: 'finance-auditbsk'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'finance-auditbsk'*/ '@views/manage/views/finance/audit-bsk/list'),
            meta: {
                title: '核实标书款',
                topNav: true,
                bread: B_1
            },
        }, 
        {
            path:"bsk/list",
            component: () => import(/*webpackChunkName: 'finance-auditbsk'*/ '@views/manage/views/finance/audit-bsk/list-bsk'),
            meta: {
                title: '订单列表',
                bread: [
                    ...B_1,
                    {
                        title: '订单列表',
                        path: '/manage/finance/auditbsk/bsk/list'
                    },
                ]
            },
        },
        {
            path:"bsk/invoice/form",
            component: () => import(/*webpackChunkName: 'finance-auditbsk'*/ '@views/manage/views/finance/invoice/form'),
            meta: {
                title: '开票',
                bread: [
                    ...B_1,
                    {
                        title: '订单列表',
                        path: '/manage/finance/auditbsk/bsk/list'
                    },
                    {
                        title: '开票',
                        path: '/manage/finance/auditbsk/bsk/invoice/form'
                    },
                ]
            },
        },
    ]
}
